import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import Uploader from 'modules/common/components/Uploader';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import * as actions from '../actions';
import * as c from '../constant';

function UploadCTCModal({ uploadCTC, getItem, updating, id, updateList }) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    cedula_image_url: '',
    cedula_no: '',
  });

  const validateForm = useFormValidator(formData, {
    cedula_image_url: 'required',
    cedula_no: 'required',
  });

  const OnSetFormData = () => {
    setFormData({
      cedula_no: _.get(updateList, 'cedula_no') || '',
      cedula_image_url: _.get(updateList, 'cedula_image_url') || '',
    });
  };

  useEffect(() => {
    if (!_.isEmpty(updateList)) {
      OnSetFormData();
    }
  }, []);

  const handleSubmit = e => {
    e.preventDefault();

    uploadCTC(id, formData, () => {
      setModal({ isOpen: false });
      getItem(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChangePhoto = key => ({ cdnUrl }) => {
    setFormData({
      ...formData,
      [key]: cdnUrl,
    });
  };

  const onChange = e => {
    return setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">
              Uploaded CTC &nbsp;
              {validateForm.renderMessage('cedula_image_url')}
            </label>
            <div className="row d-flex">
              <div className="col-12">
                <img
                  className="w-100 rounded"
                  src={
                    !_.isObject(_.get(formData, 'cedula_image_url') || '')
                      ? _.get(formData, 'cedula_image_url') || ImagePlaceholder
                      : _.get(formData, 'cedula_image_url.cdnUrl') ||
                        ImagePlaceholder
                  }
                  alt=""
                />
              </div>
              <div className="col-12 mt-2">
                <Uploader
                  className="btn btn-block btn-primary cms-bg-color-primary cms-outline-primary"
                  customLoading={<i className="fas fa-spinner fa-spin" />}
                  icon={<i className="far fa-image" />}
                  label="Upload your reference here"
                  onChange={onChangePhoto('cedula_image_url')}
                  imagesOnly
                />
              </div>
            </div>
          </div>
          <div className="col-12 form-group mt-2">
            <label htmlFor="last_name" className="form-label mb-1">
              CTC Number &nbsp;{validateForm.renderMessage('cedula_no')}
            </label>
            <input
              className="form-control"
              type="text"
              name="cedula_no"
              onChange={onChange}
              value={_.get(formData, 'cedula_no') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Upload`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UploadCTCModal.propTypes = {
  uploadCTC: PropTypes.instanceOf(Function).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPLOAD_CTC) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UploadCTCModal);
